import request from '@/utils/request';

const requestInstance = request();

const userInfoRequest = request();
userInfoRequest.interceptors.request.use(
  (config) => {
    config.baseURL = process.env.VUE_APP_GRAPH_URL;
    return config;
  },
);

// 用户个人中心
const userCenterRequest = request();
userCenterRequest.interceptors.request.use(
  (config) => {
    config.baseURL = process.env.VUE_APP_3VJIA_DOMAIN_NAME;
    config.headers.sysCode = 'devmanageweb';
    return config;
  },
);
/**
 * 登录
 * @param {Object} params 登录参数
 */
export function signIn(params) {
  return requestInstance.post('/login/', params);
}

/**
 * 获取当前登录用户信息
 */
export function getCurrentUser() {
  return userInfoRequest.get('/getUserInfo');
}


/**
 * 获取当前登录用户权限
 */
export function getAuthorty() {
  return requestInstance.get('/api/apiPlugins/list');
}

/**
 * 根据ID获取用户信息
 */
export function getUserById(id) {
  return requestInstance.get(`/user/detail/${id}`);
}


/**
 * 获取代办列表
 */
export function fetchTodoList() {
  return requestInstance.get('/todo/list/');
}

// 获取未读消息
export function getUnreadMsg(prm) {
  return userCenterRequest.post('/pcenter/usermsg/getDesignMsgListByUserId', prm);
}

/**
 * 获取当前登录用户权限
 */
export function getPermission() {
  return requestInstance.get('/api/userPermission/getUserPermission');
}
